<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { PackagingPath } from "../../../../path";
import add from "./add.vue";
import Brands from "./brands.vue";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
    add: add,
    Brands
  },
  data() {
    return {
      title: "Packaging",
      items: [
        {
          text: "List",
        },
        {
          text: "packagings",
          active: true,
        },
      ],
      selectedPackaging: {
        images: [],
      },
      packagings: [],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      filter: [],
      fields: [
        "name",
        "specifications",
        "selling_price",
        "images",
        "description",
        "brands",
        "actions",
      ],
      current_page: 1,
      search: "",
    };
  },
  watch: {
    current_page() {
      this.getPackagings();
    },
    search() {
      this.getPackagings();
    },
  },
  methods: {
    async getPackagings() {
      try {
        let response = await axios.get(this.base_url + PackagingPath.ALL, {
          params: {
            page: this.current_page,
            search: this.search,
          },
        });
        if (response.data.status == true) {
          this.packagings = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    reload() {
      this.getPackagings();
    },
    addPack() {
      this.selectedPackaging = {
        images: [],
      };
      this.$bvModal.show("bv-add-packaging");
    },
    setEdit(d) {
      this.selectedPackaging = d;
      this.$bvModal.show("bv-add-packaging");
    },
    openBrands(v) {
      this.selectedPackaging = v;
      this.$bvModal.show("add-brands");
    },
    async deleteData(d) {
      try {
        let response = await axios.delete(
          this.base_url + PackagingPath.ALL + "/" + d.id
        );
        if (response.data.status == true) {
          this.$bvToast.toast("Successfully Deleted", {
            title: `Packaging Deleted`,
            variant: "success",
            solid: true,
          });
          this.getPackagings();
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getPackagings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button @click="addPack" class="btn btn-primary mb-10 pb-10"
                  >Add Packaging</b-button
                >
                <b-modal
                  id="bv-add-packaging"
                  :title="
                    (Object.keys(selectedPackaging).length > 0
                      ? 'Edit'
                      : 'Add') + ' Packaging'
                  "
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :selectedPackaging="selectedPackaging"
                  ></add>
                </b-modal>
                <b-modal
                  id="add-brands"
                  :title="
                    Object.keys(selectedPackaging).length > 0
                      ? selectedPackaging.name
                      : ''
                  "
                  hide-footer
                >
                  <Brands :selectedPackaging="selectedPackaging"></Brands>
                </b-modal>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center mr-5">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      debounce="300"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                    <!-- <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> -->
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="packagings.key"
                :items="packagings.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="current_page"
              >
                <template v-slot:cell(images)="row">
                  <b-img
                    v-for="(im, i) in row.item.images"
                    :src="cdn + '/' + im.img_url"
                    :key="i"
                    size="20"
                  ></b-img>
                </template>
                <template v-slot:cell(brands)="row">
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="openBrands(row.item)"
                    ><i class="fa fa-list"></i
                  ></b-button>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button @click="setEdit(row.item)" variant="primary">
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <b-button
                    @click="deleteData(row.item)"
                    variant="danger"
                    class="ml-1"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="packagings.key"
                      v-model="current_page"
                      :total-rows="packagings.total"
                      :per-page="packagings.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
